/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

import type { Sharing } from "./types";

export default CustomPlatform.select<() => Sharing | null>({
  native: () => require("./sharing").default,
  web: () => require("./sharing.web").default,
  tv: () => null,
  default: () => null,
})();
